"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PostMap_1 = require("../PostMap");
var Contacts_1 = __importDefault(require("../../Contacts"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SectionHeader_1 = __importDefault(require("../SectionHeader"));
var PostDescription_1 = __importDefault(require("../PostDescription"));
var ShortInfo = function (_a) {
    var postData = _a.postData;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        postData.location && react_1.default.createElement(PostMap_1.PostMap, { marker: postData.location }),
        postData.isDeveloper && (react_1.default.createElement("div", null,
            react_1.default.createElement(SectionHeader_1.default, { title: t('POST_PREVIEW.GENERAL_DESCRIPTION').toUpperCase() }),
            react_1.default.createElement(PostDescription_1.default, { postData: postData }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.contact_area },
            react_1.default.createElement(Contacts_1.default, { contacts: postData.contacts, owner: postData.user })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.contact_area },
            react_1.default.createElement(Contacts_1.default, null))));
};
exports.default = ShortInfo;
